import React from "react";
import { Link } from "react-router-dom";

const TopicThree = () => {
  return (
    <div className="quality-section-market">
      <div className="quality-header-market">
        <h1>Global Forex Market Facts</h1>
        <p>
          Trade the world's largest financial market with deep liquidity pools,
          unmatched volume, and 24-hour global trading flexibility.
        </p>
      </div>
    </div>
  );
};

export default TopicThree;
